// extracted by mini-css-extract-plugin
export default {"description":"mrnHO9","moreLessButton":"En8omo","descriptionText":"_cwDpU"};